// SPDX-License-Identifier: AGPL-3.0-or-later
import type {Popout} from '@app/features/ui/popover';
import PopoutState from '@app/features/ui/state/Popout';

type PopoutCommand = {kind: 'open'; popout: Popout} | {kind: 'close'; key?: string | number} | {kind: 'close-all'};

function dispatchPopoutCommand(command: PopoutCommand): void {
	switch (command.kind) {
		case 'open':
			PopoutState.open(command.popout);
			return;
		case 'close':
			PopoutState.close(command.key);
			return;
		case 'close-all':
			PopoutState.closeAll();
			return;
	}
}

export function open(popout: Popout): void {
	dispatchPopoutCommand({kind: 'open', popout});
}

export function close(key?: string | number): void {
	dispatchPopoutCommand({kind: 'close', key});
}

export function closeAll(): void {
	dispatchPopoutCommand({kind: 'close-all'});
}
